import { Select, type SelectOption } from '@shinetools/lumen-react'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchAccounts } from '@features/accounts/hooks/useFetchAccounts'

interface LinkedAccountSelectProps {
  disabled: boolean
  onSelect: (accountId?: string) => void
  selectedAccountId?: string
}

export const LinkedAccountSelect = ({
  disabled,
  onSelect,
  selectedAccountId,
}: LinkedAccountSelectProps): ReactElement => {
  const { t } = useTranslation()
  const { accounts, isIdle, isLoading } = useFetchAccounts()

  const options: SelectOption[] = useMemo(
    () =>
      accounts
        .filter((account) => account.isBankAccount || String(account.accountNo ?? '').startsWith('5'))
        .map((account) => ({
          label: String(account.accountNo ?? account.name),
          value: account.id,
        })),
    [accounts],
  )

  return (
    <Select
      aria-label={t(
        'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.columns.linked_account',
      )}
      disabled={disabled || isIdle || isLoading}
      noResultsText={t('ds.nav_list.not_found')}
      onChange={onSelect}
      options={options}
      placeholder={t(
        'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.linked_account_placeholder',
      )}
      searchable
      value={selectedAccountId}
    />
  )
}
